module.exports = __webpack_public_path__ + "static/media/Work7275947d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/Work.svg
// module id = 1313
// module chunks = 0